export default __webpack_public_path__ + "images/rosabandet/icon-heart.png";